<script lang="ts" setup>
import { IEventEdit } from '@/enitites/event'
import { useEventPayoutAccountQuery } from '@/features/payoutAccounts/api/queries'

const props = defineProps<{
  eventData: IEventEdit
}>()

const { data: eventAccountData, isLoading: eventAccountLoading } = useEventPayoutAccountQuery(props.eventData.id)
</script>

<template>
  <div class="view-event">
    <p>Fill in the information about your bank account to receive payments for event tickets.</p>
    <VSkeletonLoader
      v-if="eventAccountLoading"
      type="text@2"
    />
    <template v-if="eventAccountData">
      <p>
        <span class="view-event__bold-title">Account Name:</span>
        {{ eventAccountData.account?.businessName }}
      </p>
      <p>
        <span class="view-event__bold-title">Status:</span>
        {{ eventAccountData.account?.onboardingComplete ? 'Ready' : 'Need to complete onboarding' }}
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.view-event {
  max-width: 400px;
  margin: 0 auto;

  &__bold-title {
    font-weight: var(--font-weight-semi-bold);
  }
}
</style>
